import React from 'react';
import ButtonLoader from './ButtonLoader';

const CustomPopUp = ({ title, onConfirm, onClose, confirmText, closeText, extraButtons, children, variant = 'success', initialWidth, onBlur, loader = 'false' }) => {
  return (
    <div className='custom-popup' onBlur={onBlur}>
      <div className='popup-content' style={{ width: initialWidth }}>
        <div className={`popup-head`}>
          <h4 className='outfit-medium' style={{ color: 'black' }}>
            {title || 'Title'}
          </h4>
        </div>
        <hr />
        <div className='popup-body'>{children || 'Keep your popup Body here'}</div>
        <hr />
        <div className='popup-footer d-flex align-items-center gap-2'>
          <button
            onClick={onConfirm}
            className='btn-modal-save outfit-medium d-flex align-items-center gap-2'
            style={{ background: variant === 'error' ? 'rgb(220, 53, 69)' : '#e8590c', borderColor: variant === 'error' ? 'rgb(220, 53, 69)' : '#e8590c' }}
            disabled={loader}
          >
            {loader && <ButtonLoader />} <span className='outfit-regular'>{confirmText || 'Yes'}</span>
          </button>
          {closeText && (
            <button onClick={onClose} className='btn-modal-cancel outfit-medium'>
              {closeText || 'No'}
            </button>
          )}
          {extraButtons && extraButtons}
        </div>
      </div>
    </div>
  );
};

export default CustomPopUp;
